"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNotificationConfig = void 0;
const react_1 = __importDefault(require("react"));
const _1 = require(".");
const atoms_1 = require("../../atoms");
const getNotificationConfig = (type) => {
    switch (type) {
        case _1.NotificationType.COMPLETED:
            return {
                bg: 'bg-blue-200',
                icon: (react_1.default.createElement(atoms_1.Icon.CircleCheck, { width: "20", height: "20", className: "text-blue-400" })),
            };
        case _1.NotificationType.NEW:
            return {
                bg: 'bg-green-200',
                icon: react_1.default.createElement(atoms_1.Icon.NotificationStar, { className: "text-green-700" }),
            };
        case _1.NotificationType.WARNING:
            return {
                noIcon: true,
                bg: 'bg-orange-300',
                icon: (react_1.default.createElement(atoms_1.Icon.CircleExclamation, { width: "20", height: "20", className: "text-orange-700" })),
            };
        default:
            return null;
    }
};
exports.getNotificationConfig = getNotificationConfig;
//# sourceMappingURL=getNotificationConfig.js.map